import Vue from 'vue';
import Vuetify from 'vuetify';
import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);
const vuetify = new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        dark: localStorage.darkMode ? JSON.parse(localStorage.darkMode) : false,
        themes: {
            light: {
                appbarColor: "#f4f8f9",
                pageBackground: "#f4f8f9",
                hamburgerCloseColor: "#cf1f5a",
                impersonationBarColor: "#cf1f5a",
                menuColor: '#ffffff',
                myDataGroupHeadingIconColor: "#286480",
                myDataGroupIconColor: "#60aacc",
                vacationPlannerIconColor: "#e39d42",
                devIconColor: "#cf1f5a",
                adminGroupHeadingColor: "#752d55",
                adminGroupIconColor: "#a33c76",
                financeGroupHeadingColor: '#249413',
                financeGroupIconColor: '#3a9e5b',
                themeGradientStart: '#34495e',
                themeGradientEnd: '#2c3e50',
                color: '#34495e',
                colorAdd: '#019688',
                footerBg: "#f4f8f9",
                footerText: "#737676",
                plannedAbsenceItemColor: "#e39d42",
                componentBg: '#ffffff',
                componentBg2: '#ffffff',
                text: '#333333',
                disabled: '#dddddd'
            },
            dark: {
                secondary: '#dddddd',
                appbarColor: "#272727",
                pageBackground: "#272727",
                hamburgerCloseColor: "#cf1f5a",
                impersonationBarColor: "#cf1f5a",
                myDataGroupHeadingIconColor: "#286480",
                myDataGroupIconColor: "#60aacc",
                vacationPlannerIconColor: "#e39d42",
                devIconColor: "#cf1f5a",
                adminGroupHeadingColor: "#752d55",
                adminGroupIconColor: "#a33c76",
                financeGroupHeadingColor: '#249413',
                financeGroupIconColor: '#3a9e5b',
                colorAdd: '#019688',
                color: '#34495e',
                plannedAbsenceItemColor: "#e39d42",
                themeGradientStart: '#34495e',
                themeGradientEnd: '#2c3e50',
                componentBg: '#171717',
                componentBg2: '#1e1e1e',
                text: '#ffffff',
                disabled: '#373737'
            },
        },
    },
});
export default vuetify;
